import { registerPlugin } from '../plugins/plugin_register';

export class DefaultRegistry {
  public static async register(): Promise<void> {
    const { UIConfig1 } = await import('../plugins/service_plugins/ui_config/ui_config1');
    registerPlugin(UIConfig1);
  }
  public static async registerCad(): Promise<void> {}
  public static async registerCatia(): Promise<void> {}
  public static async registerSolidWorks(): Promise<void> {}
  public static async registerNX(): Promise<void> {}
}
